module.exports = __webpack_public_path__ + "static/img/xm3.b93beab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/xm/xm3.png
// module id = Y36d
// module chunks = 0